module.exports = __webpack_public_path__ + "img/logo.ac07f75c.png";